/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import client from "#client";
import type { Client, RequestConfig, ResponseErrorConfig } from "#client";
import type { OrgUnitTableListPathOrgUnitId, OrgUnitTableListStatus200 } from "../types/OrgUnitTableList.ts";

function getOrgUnitTableListUrl(org_unit_id: OrgUnitTableListPathOrgUnitId) {
	const res = { method: "GET", url: `/api/org_unit/${org_unit_id}/table/` as const };

	return res;
}

/**
 * @description Представление списка столов и залов точки организации.
 * {@link /api/org_unit/:org_unit_id/table/}
 */
export async function orgUnitTableList(org_unit_id: OrgUnitTableListPathOrgUnitId, config: Partial<RequestConfig> & { client?: Client } = {}) {
	const { client: request = client, ...requestConfig } = config;

	const res = await request<OrgUnitTableListStatus200, ResponseErrorConfig<Error>, unknown>({
		method: "GET",
		url: getOrgUnitTableListUrl(org_unit_id).url.toString(),
		...requestConfig,
	});

	return res.data;
}
